import api from '../../../services/apiConfig';

export interface SupervisorOrderListItem {
  id: number;
  id_externo: number;
  cliente_id: number;
  ultima_alteracao: string | null;
  status: string;
  total: number;
  condicao_pagamento: string;
  data_emissao: string;
  cliente_razao_social: string | null;
  cliente_cnpj: string;
  cliente_cidade: string | null;
  cliente_estado: string;
  cliente_telefone: string | null;
  pedido_situacao: number | null;
  operacoes_fiscais: number;
  obs: string | null;
  operacao_fiscal_desc: string | null;
  VENDEDOR_NOME: string | null;
}

export interface SupervisorOrdersResponse {
  items: SupervisorOrderListItem[];
  pagination: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
  };
}

export interface ExternalOrderItemGrade {
  id: number;
  id_pedido_externo_item: number;
  tamanho: string;
  quantidade: number;
}

export interface ExternalOrderItem {
  id: number;
  id_externo: number;
  quantidade: number;
  preco_item: number;
  subtotal: number | null;
  referencia: string;
  descricao: string | null;
  tabela_preco: string;
  opcional: string | null;
  grades: ExternalOrderItemGrade[];
}

export interface SupervisorOrderDetails {
  id: number;
  id_externo: number;
  cliente_id: number;
  ultima_alteracao: string | null;
  status: string;
  total: number;
  condicao_pagamento: string;
  data_emissao: string;
  cliente_razao_social: string | null;
  cliente_cnpj: string;
  cliente_cep: string | null;
  cliente_rua: string | null;
  cliente_cidade: string | null;
  cliente_estado: string;
  cliente_telefone: string | null;
  usuario_id: number | null;
  obs: string | null;
  erro: string | null;
  operacoes_fiscais: number;
  pedido_situacao: number | null;
  operacao_fiscal_desc: string | null;
  VENDEDOR_NOME: string | null;
  BASE_PRODUCAO_NOME: string | null;
  CLIENTE_EMAIL: string | null;
  SEGMENTO_CLASSE: string | null;
  itens: ExternalOrderItem[];
  amostra: any | null;
}

export const fetchSupervisorOrders = async (
  page = 1,
  limit = 20,
  filters: {
    search?: string;
    dataI?: string;
    dataF?: string;
    status?: string;
  } = {}
) => {
  return api.get<SupervisorOrdersResponse>('/supervisor/orders', {
    params: { page, limit, ...filters },
  });
};

export const fetchSupervisorOrderDetail = async (orderId: number) => {
  return api.get<SupervisorOrderDetails>(`/supervisor/orders/${orderId}`);
};

export const approveOrRejectOrder = async (orderId: number, status: number) => {
  return api.put(`/supervisor/orders/${orderId}/status`, { status });
};
